<template>
  <div class="page-fixed">
    <detail-page
      :item="dataList"
      :index="nowIndex"
      :dataleng="dataList.length"
      type="video"
    ></detail-page>
  </div>
</template>

<script>
import DetailPage from '../components/detail'
export default {
  components: { DetailPage },
  data() {
    return {
      nowIndex: 1,
      dataList: {
        title: '大会上看到看手机看的是空间都是的哈里看见的拉动',
        source: '北京国际服务贸易中心',
        data: '1595347200000',
        posterUrl:
          'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3252521864,872614242&fm=26&gp=0.jpg',
        src: require('@/assets/video/video1.mp4'),
        content:
          '当今世界第三季度老实交代第三季度老是奇偶的搜都是为了电视剧的历史的老师觉得老师的'
      }
    }
  },
  mounted() {},
  methods: {
    onChange(index) {
      this.nowIndex = index += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe,
.van-swipe-item {
  width: 100%;
  height: 100%;
}
</style>
